
import { supabase } from '@/integrations/supabase/client';

// Get a category by name
export const getCategoryByName = async (categoryName: string) => {
  const { data, error } = await supabase
    .from('categories')
    .select('id')
    .eq('name', categoryName)
    .maybeSingle();

  if (error) {
    console.error("Error fetching category:", error);
    return null;
  }
  
  return data;
};

// Create a new category
export const createCategory = async (categoryName: string) => {
  const { data, error } = await supabase
    .from('categories')
    .insert({ name: categoryName })
    .select()
    .single();
  
  if (error) {
    console.error("Error creating category:", error);
    return null;
  }
  
  return data;
};
